@if (show) {
  <div class="signup-login">
    @if (state === 'display') {
      <div>
        @if (mode === 'login') {
          <form id="login" [formGroup]="loginForm" (onSubmit)="login()" (keyup.enter)="login()">
            <div class="bold">Welcome Back</div>
            <div class="subtext">Log in for easy checkout</div>
            <label for="login-email">Email</label>
            <input id="login-email" type="text" name="email" formControlName="email" required>
            <label for="login-password">Password</label>
            <input id="login-password" type="password" name="password" formControlName="password" (blur)="login()" (keyup.enter)="login()"  required>
            <div class="flex subtext">
              <div class="flex-grow-1">
                <button class="btn invert sm-square" (click)="login()">Login</button>
              </div>
              <div>Don't have an account?&nbsp;</div>
              <div class="underline" (click)="mode = 'signup'">Signup now</div>
            </div>
            <!-- <div class="subtext">Don't have an account? <div class="underline" (click)="mode = 'signup'">Sign Up</div></div> -->
          </form>
        }
        @if (mode === 'signup') {
          <form id="signup" [formGroup]="signupForm"  (onSubmit)="signup()">
            <div class="flex">
              <div class="bold">Create Account</div>
              @if (subscription) {
                <i>&nbsp;(Required if you are signing up for a membership)</i>
              } @else {
                <i>&nbsp;(Optional)</i>
              }
            </div>
            <label for="username">Email</label>
            <input
              id="username"
              type="email"
              name="email"
              formControlName="email"
              required
              >
            <label for="signup-password">Create Password</label>
            <input
              id="signup-password"
              type="password"
              name="password"
              formControlName="password"
              required
              (keyup.enter)="signup()"
              minlength="8"
              >
            @if (signupError) {
              <span class="error">{{signupError}}</span>
            }
            <div class="flex">
              <div class="flex-grow-1">
                <button class="btn invert sm-square" (click)="signup()">Create Account</button>
              </div>
              <div class="flex subtext" style="font-size: 12px">
                <div>Already have an account?&nbsp;</div>
                <div class="underline" (click)="mode = 'login'">Login Now</div>
              </div>
            </div>
          </form>
        }
      </div>
    }
    @if (state === 'success') {
      <div>
        <div class="bold">Success!</div>
        <div class="subtext">You are now logged in</div>
      </div>
    }
    @if (state === 'inProgress') {
      <div>
        <div class="bold">{{ progressMessage }}</div>
      </div>
    }
    @if (state === 'finished') {
      <div>
        @if (mode === 'signup') {
          <div>
            <div class="bold">Success!</div>
            <div class="subtext">Account created and logged in with {{ signupForm.get('email').value }}</div>
          </div>
        }
        @if (mode === 'login') {
          <div>
            Welcome back, {{ _user?.firstName }}!
          </div>
        }
      </div>
    }
    @if (state === 'error') {
      <div class="flex">
        <div class="flex-grow-1">{{ error }}</div>
        <button class="btn btn-sm" (click)="confirmError()">Ok</button>
      </div>
    }
  </div>
}
